// auth.service.ts
import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // API path
  apiUrl = environment.apiUrl;
  @Output() accountChange: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router,
    private http: HttpClient,
    private jwtHelper: JwtHelperService
  ) { }

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  // Handle API errors
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if(error.status==401) {
        return throwError(
          'Mauvais Login ou mot de passe');
      }
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }


  // Verify user credentials on server to get token
  loginForm(data): Observable<any> {
    return this.http
      .post(this.apiUrl + '/auth.php', data, this.httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      );
  }

  // After login save token and other values(if any) in localStorage
  setUser(user) {
    localStorage.setItem('nom', user.nom);
    localStorage.setItem('prenom', user.prenom); 
    localStorage.setItem('id', user.id);
    localStorage.setItem('telPortable', user.telPortable);
    localStorage.setItem('mail', user.mail);
    localStorage.setItem('access_token', user.access_token);
    localStorage.setItem('accesVueTousUsers', user.accesVueTousUsers);
    localStorage.setItem('admin', user.admin);
    localStorage.setItem('commercial', user.commercial);
    this.accountChange.emit('change');
  }

  // Checking if token is set
  isLoggedIn() {
    return localStorage.getItem('access_token') != null;
  }

  // Checking if token is not expired
  isTokenExpired() {
    return this.jwtHelper.isTokenExpired(localStorage.getItem('access_token'));

  }

  // After clearing localStorage redirect to login screen
  logout() {
    localStorage.clear();
    this.accountChange.emit('change');
    this.router.navigate(['/auth/login']);
  }


  // Get data from server for Dashboard
  getData(data): Observable<any> {
    return this.http
      .post(this.apiUrl + '/auth.php', data, this.httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      );
  }

}